module.exports = __webpack_public_path__ + "static/media/soundsmessage.ead1150a.mp3";